// Messages for API error codes (error.code) — shown instead of raw server text.
const ru: Record<string, string> = {
  'err.generic': 'Что-то пошло не так. Попробуйте ещё раз.',
  'err.network': 'Нет соединения с сервером. Черновики сохраняются на устройстве.',
  'err.UNAUTHENTICATED': 'Нужно войти заново.',
  'err.SESSION_EXPIRED': 'Сессия истекла — войдите снова.',
  'err.FORBIDDEN': 'Нет доступа.',
  'err.NOT_FOUND': 'Не найдено или доступ закрыт.',
  'err.CSRF_REJECTED': 'Запрос отклонён из соображений безопасности. Обновите страницу.',
  'err.RATE_LIMITED': 'Слишком много попыток. Подождите немного.',
  'err.INVALID_CODE': 'Неверный или устаревший код.',
  'err.CODE_EXPIRED': 'Срок действия кода истёк. Запросите новый.',
  'err.TOO_MANY_ATTEMPTS': 'Слишком много неверных попыток. Запросите новый код.',
  'err.REVISION_CONFLICT': 'Страница изменена на другом устройстве.',
  'err.SESSION_LOCKED': 'Работа уже отправлена и не редактируется.',
  'err.EXAM_TIME_EXPIRED': 'Время экзамена вышло.',
  'err.EXAM_NOT_ACTIVE': 'Экзамен уже завершён.',
  'err.NOT_SYNCED': 'Не все страницы синхронизированы. Дождитесь синхронизации.',
  'err.TRANSCRIPT_NOT_CONFIRMED': 'Сначала подтвердите распознанный текст.',
  'err.TRANSCRIPT_STALE': 'Текст изменился — обновите страницу.',
  'err.REFERENCE_HIDDEN': 'Образец скрыт в строгом режиме.',
  'err.AI_UNAVAILABLE': 'Сервис ИИ сейчас недоступен. Работа сохранена — повторите позже.',
  'err.AI_BUDGET_EXCEEDED': 'Месячный лимит расходов на ИИ исчерпан.',
  'err.AI_INVALID_OUTPUT': 'ИИ вернул некорректный ответ. Повторите попытку.',
  'err.PAYLOAD_TOO_LARGE': 'Слишком большой объём данных.',
  'err.TEACHER_NOT_FOUND': 'Преподаватель с таким адресом не приглашён.',
  'err.VALIDATION_FAILED': 'Проверьте введённые данные.',
  'err.CONFLICT': 'Конфликт: действие уже выполняется.',
};
const en: Record<string, string> = {
  'err.generic': 'Something went wrong. Please try again.',
  'err.network': 'Cannot reach the server. Drafts are kept on this device.',
  'err.UNAUTHENTICATED': 'Please sign in again.',
  'err.SESSION_EXPIRED': 'Your session expired — sign in again.',
  'err.FORBIDDEN': 'Access denied.',
  'err.NOT_FOUND': 'Not found or no access.',
  'err.CSRF_REJECTED': 'Request rejected for security reasons. Reload the page.',
  'err.RATE_LIMITED': 'Too many attempts. Please wait.',
  'err.INVALID_CODE': 'Invalid or expired code.',
  'err.CODE_EXPIRED': 'The code has expired. Request a new one.',
  'err.TOO_MANY_ATTEMPTS': 'Too many wrong attempts. Request a new code.',
  'err.REVISION_CONFLICT': 'This page was changed on another device.',
  'err.SESSION_LOCKED': 'This attempt was submitted and is read-only.',
  'err.EXAM_TIME_EXPIRED': 'Exam time is over.',
  'err.EXAM_NOT_ACTIVE': 'The exam has ended.',
  'err.NOT_SYNCED': 'Some pages are not synced yet. Wait for sync.',
  'err.TRANSCRIPT_NOT_CONFIRMED': 'Confirm the recognised text first.',
  'err.TRANSCRIPT_STALE': 'The text changed — reload.',
  'err.REFERENCE_HIDDEN': 'The model text is hidden in strict mode.',
  'err.AI_UNAVAILABLE': 'The AI service is unavailable. Your work is saved — try later.',
  'err.AI_BUDGET_EXCEEDED': 'The monthly AI budget has been reached.',
  'err.AI_INVALID_OUTPUT': 'The AI returned an invalid response. Try again.',
  'err.PAYLOAD_TOO_LARGE': 'Too much data.',
  'err.TEACHER_NOT_FOUND': 'No invited teacher with this address.',
  'err.VALIDATION_FAILED': 'Please check your input.',
  'err.CONFLICT': 'Conflict: an action is already running.',
};
export default { ru, en };
